import React from 'react';
import { Typography, Box } from '@mui/material';
import { ShowDate } from 'framework/ui/ui-builder';
import { DATE_FORMAT } from 'framework/utils';

interface EmployeeHealthcheckTimelineRecordLayoutProps {
  item: any;
}

const EmployeeHealthcheckTimelineRecordLayout: React.FC<EmployeeHealthcheckTimelineRecordLayoutProps> = ({ item }) => {
  if (!item || !item.healthcheck) {
    return null;
  }

  const { healthcheck } = item;

  return (
    <Box p={2}>
      <Typography variant="subtitle1" gutterBottom>
        Healthcheck
      </Typography>
      <Typography variant="body1" gutterBottom>
        <Typography variant="subtitle1" component="span">
          Date:
        </Typography>{' '}
        <ShowDate dateUTC={healthcheck.date} format={DATE_FORMAT.SIMPLE} />
      </Typography>
      {healthcheck.description && (
        <Typography variant="body1">
          <Typography variant="subtitle1" component="span">
            Description:
          </Typography>{' '}
          {healthcheck.description}
        </Typography>
      )}
    </Box>
  );
};

export default EmployeeHealthcheckTimelineRecordLayout;
